module.exports = __webpack_public_path__ + "img/remover.b400e5a1.png";